import React from "react";
import { motion } from "framer-motion"
import {
    Row,
    Col,
    Card,
    CardBody,
    Input
} from "reactstrap";
import { connect } from 'react-redux';
import { searchUsersByName, userCheckProfile } from '../../../redux/actions/admin.action';
import discordNoLogo from "assets/img/discordNoLogo.png";

const UserSearch = (props) => {
    const [userName, setuserName] = React.useState('');
    return (
            <>
                {<motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                    <Card className="adminToolBody">
                        <div className="adminToolBody-userSearch">
                            Pseudo:
                            <div className="searchInput">
                                <Input placeholder="Username" value={userName} onChange={(e) => setuserName(e.target.value)} type="text" />
                                <i className="searchInput-btn tim-icons icon-check-2" onClick={() => props.searchUsersByName(userName)}/>
                            </div>
                        </div>
                    </Card>
                </motion.div>}
                {props?.users?.searchUsersList && props.users?.searchUsersList?.length > 0 && <div className="adminToolBody">
                    <Row >
                    {props?.users?.searchUsersList.map(user => {return(
                        <Col className="userBody selectable" xl="2" lg="3" md="4" sm="6" xs="12">
                            <motion.div whileTap={{ scale: 0.97}} initial={{ opacity: 0, y: 400 }} animate={{ opacity: 1, y: 0, transition: { duration: 0.2 } }}>
                                <Card>
                                    <CardBody onClick={() => props.userCheckProfile(user.sid)}>
                                        <img className="userAvatar" alt="avatar" src={user.avatar ? `https://cdn.discordapp.com/avatars/${user.avatar}.png?size=128` : discordNoLogo} onError={(e)=>{e.target.onerror = null; e.target.src = discordNoLogo}}/>
                                        <div className="userInfos">
                                            <div className="name">{user.pseudo}</div>
                                            <div>Plan: {user.plan}</div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </motion.div>
                        </Col>)})}
                    </Row>
                </div>}
            </>
    );
};

const mapDispatchToProps = {
    searchUsersByName,
    userCheckProfile
};

const mapStateToProps = (state) => {
    const { users } = state.admin;
    return { users };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSearch);